import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {bonusAccrualByBrand_template} from "../components/templates/bonusAccrualByBrand_template";
import {header} from "./header";


declare var ko: any;
declare var page: any;

export class bonus_accrual_by_brand extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: bonusAccrualByBrand_template;

    protected getModuleName() {
        return "bonus_accrual_by_brand";
    }

    buildContent(): Array<Element> {
        this.elementsList = new bonusAccrualByBrand_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Bonus Accrual By Brand");
        return [this.elementsList.build()];
    }

    public fillPage(): void {

        this.getFilterReference();
    }

    protected filterSimpleOnChange() {
        this.filterList();
    }


    protected filterList() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let element = document.getElementById("data-list-result")
        this.loadingIn(element);

        let subViewModel = this.elementsList.getViewModelForRequest();
        let usrReq_url: string;

        usrReq_url = '/api/bonusAccrual/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    console.log(responseParsed.data)
                    obj.setResults(responseParsed.data);

                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/' + obj.getVnAppZone().app.params.idBrand + '/home');
                } else {

                    obj.elementsList.validationsList.setSingleMessage({
                        field: "error",
                        label: req.request.status,
                        message: responseParsed.message
                    });
                    window.scrollTo(0, 0);
                }

                // LOADING : ends
                let element = document.getElementById("data-list-result")
                obj.loadingOut(element);
                // obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem('"list-action-body"'));
            }
        }
    }

    protected getFilterReference() {

        //LOADING : starts
        let element = document.getElementById("data-list-result")
        this.loadingIn(element);
        // this.loadingIn(this.elementsList.builtTemplate.children.namedItem('"list-action-body"'));


        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string;

        usrReq_url = '/api/transactions/references';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push();
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function () {

            if (localCheck == _myThis.XHRHdl.requestId) {
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onGetfilterReferenceRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onGetfilterReferenceRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateReferenceList(responseParsed.data);
                obj.filterList();
            })
        }
    }

    protected updateReferenceList(responseParsed: any) {

        this.elementsList.getTemplateViewModel().brandFilter.setOptions(responseParsed.brands);
        let currentYear = new Date().getFullYear();
        let years = [];
        for(var i = currentYear-2; i < currentYear+3; i++){
            let year = { id : i, name : i };
            years.push(year);
        }
        this.elementsList.getTemplateViewModel().yearFilter.setOptions(years);
        this.elementsList.getTemplateViewModel().yearFilter.setSelectedOption(currentYear);
    }

    protected setResults(responseParsed) {

        this.elementsList.setFreelancersResult(responseParsed.freelancers);
        this.elementsList.setEmployeesResult(responseParsed.employees);
    }

    protected filterMultipleSelectorOnChange(){

        this.filterList();
    }

    protected filterDropdownOnChange() {

        this.elementsList.setMonths(this.elementsList.getMonths()); //reset months
        this.filterList();
    }

    protected filterDateOnChange(){

        this.filterList();
    }

    public save(){

        this.elementsList.builtTemplate.classList.add("loading");

        let formReq_url: string = '/api/bonusAccrual/save/';
        let formReq_params: Array<Array<string>> = [];

        let data = this.elementsList.getPostRequestData();
        formReq_params.push(["data", ko.toJSON(data)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onSaveReturn;
        XHRHdl.execute();
    }

    protected onSaveReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

            });
            obj.elementsList.builtTemplate.classList.remove("loading");
        }
    }

    public cancel(){

        page('/');
    }
}



// WEBPACK FOOTER //
// ./js/modules/bonus_accrual_by_brand.ts